// Maps the server's canonical room/knock error codes to a translated,
// user-readable string. Every socket ack that can fail carries one of these
// codes (see Backend/utils/roomAccess.js and Backend/socket/knockStore.js
// for where each one originates) and each has a matching key under
// `errors.*` in the translation dictionaries; anything without a matching
// code falls back to the ack's own `message` field (untranslated - it comes
// straight from the backend), or a generic string.
export function describeError(ack, t) {
    if (!ack) return t('errors.generic');
    if (ack.code) {
        const translated = t(`errors.${ack.code}`);
        if (translated !== `errors.${ack.code}`) return translated;
    }
    return ack.message || t('errors.generic');
}
